import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import h from '../../helpers/common';
import { useTaFeed } from '../../hooks/data/useTaFeed';
import { __ } from '../../translations';
import { transformLinearResponse } from '../../utils/transformResponse/thinkAnalyticsResponse';
import { transformVOD } from '../../utils/vodTransformer';
import { GenericVodCarousel } from './GenericVodCarousel';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import GenericVerticalList from './GenericVerticalList';
import { LiveTvTrending } from './LiveTvTrending';
import { useSelector } from 'react-redux';
import { IStore } from '../../interfaces/StoreTypes';
type TaFeedCarouselProps = {
    carousel: Carousel;
};

export const TaFeedCarousel: React.FC<TaFeedCarouselProps> = ({ carousel }) => {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();
    const { data, isLoading, error } = useTaFeed(carousel);
    const { userChannels } = useSelector((state: IStore) => state.liveTv);
    // Early return if there's an error
    if (error) {
        return;
    }

    // Only render if we have data or are loading
    if (isLoading || data?.entries?.length) {
        if (carousel?.layoutType?.toUpperCase() === 'VERTICAL') {
            return (
                <GenericVerticalList
                    isLoading={isLoading}
                    content={data?.entries?.map((e) =>
                        transformVOD({ ...e, media: [{ content: e?.content }] }, config.promotionProviderImages)
                    )}
                    meta={{
                        title: {
                            en: __(carousel.title_resource_key, { lng: 'en' }),
                            ar: __(carousel.title_resource_key),
                        },
                    }}
                    carousel={carousel}
                    params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                    shouldShowNumbers={carousel?.wcpType === 'TOP_TEN_PORTRAIT' ? true : false}
                />
            );
        } else if (carousel?.wcpType === 'LANDSCAPE_LIVETV_TRENDING') {
            return (
                <LiveTvTrending
                    isLoading={isLoading}
                    content={data?.entries?.map((e) => {
                        return transformLinearResponse(e, config.promotionProviderImages, userChannels);
                    })}
                    meta={{ title: { en: carousel.title_resource_key, ar: carousel.title_resource_key } }}
                    params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                    carousel={carousel}
                />
            );
        } else {
            return (
                <GenericVodCarousel
                    isLoading={isLoading}
                    language={h.getLang()}
                    content={data?.entries?.map((e) =>
                        transformVOD({ ...e, media: [{ content: e?.content }] }, config.promotionProviderImages)
                    )}
                    id={carousel.id}
                    title={carousel.title_resource_key}
                    name={carousel.id}
                    params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                    data_stream={carousel.id}
                    meta={{ title: { en: carousel.title_resource_key, ar: carousel.title_resource_key } }}
                    carousel={carousel}
                    data={data}
                />
            );
        }
    }

    // If no data and not loading, return null
    return null;
};
